import type { UserProfile } from "@/services/authService";
import { Role } from "@/types/user";

type AddressRoleSource =
  | Pick<UserProfile, "role" | "effectiveRole">
  | null
  | undefined;

// PUT /hotels/:id keeps `address` only when the catalog role is TENANT_ADMIN
// (backend HotelController.update, stripBrandIdentityFields). /auth/me sends
// that role as effectiveRole.baseRole; `role` carries a custom role's name.
export const canSaveHotelAddress = (profile: AddressRoleSource): boolean =>
  (profile?.effectiveRole?.baseRole ?? profile?.role) === Role.TENANT_ADMIN;
